exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submit_style[data-v-4cf7e7ac] {\n    width: 120px;\n}\n.mypagebackbutton[data-v-4cf7e7ac] {\n    width: 250px;\n}\n.friend-line[data-v-4cf7e7ac] {\n    margin-bottom: 20px;\n}\n.mypagebackcontent[data-v-4cf7e7ac] {\n    margin-left: -15px;\n    margin-right: -15px;\n}\n@media screen and (max-width: 575px) {\n.submit_style[data-v-4cf7e7ac] {\n    width: 50%;\n}\n.mypagebackbutton[data-v-4cf7e7ac] {\n    width: 50%;\n}\n}\n", ""]);

// exports
